import { render, staticRenderFns } from "./MembershipPlansSettings.vue?vue&type=template&id=e3aa0962&"
import script from "./MembershipPlansSettings.vue?vue&type=script&lang=js&"
export * from "./MembershipPlansSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports